module.exports = __webpack_public_path__ + "static/media/mask-pink@2x.ecaf9671.png";